import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ClickOutside from "../../ClickOutside";
import UserOne from "../../../assest/images/user-01.png";
import { useDispatch, useSelector } from "react-redux";
import { clearUser } from "../../../redux/slices/userSlice";
import { FaRegUser } from "react-icons/fa";
import { TbDashboard } from "react-icons/tb";
import { IoLogOutOutline } from "react-icons/io5";

const DropdownUser = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userData, userProfileData } = useSelector((state) => state.user);

  const closeDropdown = () => setDropdownOpen(false);

  const handleToggleDropdown = (event) => {
    event.preventDefault();
    setDropdownOpen((prev) => !prev);
  };

  const handleLogout = () => {
    closeDropdown();
    dispatch(clearUser());
    navigate("/");
  };

  const handleNavigate = (path) => {
    closeDropdown();
    navigate(path);
  };

  return (
    <ClickOutside onClick={() => setDropdownOpen(false)} className="relative">
      <Link
        onClick={handleToggleDropdown}
        className="flex items-center gap-3"
        to="#"
      >
        <span className="h-11 w-11 rounded-full ring-2 ring-orange-500 ring-offset-2 overflow-hidden shrink-0">
          <img
            src={userData?.profile_image ? userData?.profile_image : UserOne}
            alt="User"
            className="h-full w-full object-cover"
          />
        </span>

        <span className="text-left block">
          <span className="block text-base font-bold text-black dark:text-white">
            {userProfileData.full_name || "Thomas Anree"}
          </span>
        </span>

        <svg
          className={`fill-orange-500 transition-transform duration-200 ${
            dropdownOpen ? "rotate-180" : ""
          }`}
          width="14"
          height="9"
          viewBox="0 0 12 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.410765 0.910734C0.736202 0.585297 1.26384 0.585297 1.58928 0.910734L6.00002 5.32148L10.4108 0.910734C10.7362 0.585297 11.2638 0.585297 11.5893 0.910734C11.9147 1.23617 11.9147 1.76381 11.5893 2.08924L6.58928 7.08924C6.26384 7.41468 5.7362 7.41468 5.41077 7.08924L0.410765 2.08924C0.0853277 1.76381 0.0853277 1.23617 0.410765 0.910734Z"
          />
        </svg>
      </Link>

      {dropdownOpen && (
        <div className="absolute right-0 mt-3 flex w-64 flex-col overflow-hidden rounded-xl border border-gray-100 bg-white shadow-lg">
          <button
            onClick={() => handleNavigate("/user/profile")}
            className="flex items-center gap-3 px-5 py-3.5 text-sm font-medium text-gray-700 transition-colors duration-200 hover:bg-orange-50 hover:text-orange-500"
          >
            <FaRegUser size={18} />
            My profile
          </button>
          <button
            onClick={() => handleNavigate("/dashboard")}
            className="flex items-center gap-3 px-5 py-3.5 text-sm font-medium text-gray-700 transition-colors duration-200 hover:bg-orange-50 hover:text-orange-500"
          >
            <TbDashboard size={18} />
            Dashboard
          </button>
          <div className="h-px bg-gray-100" />
          <button
            type="button"
            onClick={handleLogout}
            className="flex items-center gap-3 px-5 py-3.5 text-sm font-medium text-rose-500 transition-colors duration-200 hover:bg-rose-50"
          >
            <IoLogOutOutline size={19} />
            Log out
          </button>
        </div>
      )}
    </ClickOutside>
  );
};

export default DropdownUser;